<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'assignatures', params: {page: $route.params.listPage || 1, sort: $route.params.listSort || 'assignatura_nom_ca asc'}}">{{$t('Assignatures')}}</router-link-locale></li>
        <li v-if="response.assignatura && response.assignatura[`assignatura_nom_${locale}`]" class="breadcrumb-item active" aria-current="page">{{ response.assignatura[`assignatura_nom_${locale}`] }}</li>
        <li v-else-if="response.assignatura" class="breadcrumb-item active" aria-current="page">{{ response.assignatura.assignatura_nom_ca }}</li>
      </ol>
    </nav>


    <h1  class="d-flex justify-content-between">
      <span v-if="response.assignatura && response.assignatura[`assignatura_nom_${locale}`]">{{ response.assignatura[`assignatura_nom_${locale}`] }}</span>
      <span v-else-if="response.assignatura">{{ response.assignatura.assignatura_nom_ca }}</span>
      <span class="text-secondary h5" style="position: relative; top: 15px;">Activitats<span class="badge rounded-pill badge-upc ms-2">{{materialCount}}</span> </span>
    </h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.assignatura">

          <div class="card-body">

            <div class="m-t-20 row">
              <div class="col-md-2 col-xs-12 text-center mb-2">
                <i style="color: #5fa728;" class="fa fa-book-open-reader fa-8x mb-2"></i>
              </div>
              <div class="col-md-10">
                <div class="row mb-2">
                  <!--div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Nom')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <span v-if="response.assignatura[`assignatura_nom_${locale}`]" class="text-blue">{{ response.assignatura[`assignatura_nom_${locale}`] }}</span>
                    <span v-else class="text-blue">{{ response.assignatura.assignatura_nom_ca }}</span>
                  </div-->
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Vigent')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <span v-if="response.assignatura.assignatura_activa" class="badge bg-success">{{$t('Si')}}</span>
                    <span v-else class="badge bg-danger">{{ $t('No') }}</span>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.assignatura.assignatura_sigles">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Sigles')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.assignatura.assignatura_sigles }}
                  </div>
                </div>

                <div class="row mb-2" v-if="response.assignatura && isGuiaDisponible(new Date().getFullYear() - (new Date().getMonth() < 8 ? 1 : 0), getIdiomaForGuia(locale))">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Guia docent')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                     <router-link-locale 
                       :to="{name: 'guiaDocent', params: {id: response.assignatura.id, curs: new Date().getFullYear() - (new Date().getMonth() < 8 ? 1 : 0)}, query: {page: $route.params.listPage, sort: $route.params.listSort}}" 
                       class="btn btn-innovation px-3"
                     >
                        <i class="fa-solid fa-book-open"></i> {{$t('Veure guia actual')}}
                     </router-link-locale>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.assignatura && isBibliografiaDisponible(new Date().getFullYear() - (new Date().getMonth() < 8 ? 1 : 0))">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Bibliografia')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                     <router-link-locale 
                       :to="{name: 'bibliografia', params: {id: response.assignatura.id, curs: new Date().getFullYear() - (new Date().getMonth() < 8 ? 1 : 0)}, query: {page: $route.params.listPage, sort: $route.params.listSort}}" 
                       class="btn btn-innovation px-3"
                     >
                        <i class="fa-solid fa-book"></i> {{$t('Bibliografia recomanada')}}
                     </router-link-locale>
                  </div>
                </div>

                <hr v-if="response.assignatura.assignatura_titulacions_actives || (response.organitzacio && response.organitzacio.organitzacio_titulacions_no_actives)">

                <div class="row mb-2" v-if="response.assignatura.assignatura_centres">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Centres')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="centre in (response.assignatura.assignatura_centres.filter((valor, indiceActual, arreglo) => arreglo.indexOf(valor) === indiceActual))" v-bind:key="centre">
                      <span class="d-block mb-1"><router-link :to="{name: 'organitzacio', params: {id: centre}}" >{{ $t(centre) }}</router-link></span>
                    </div>
                  </div>
                </div>


                <div class="row mb-2" v-if="response.assignatura.assignatura_titulacions_actives">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="(titulacio, index) in response.assignatura.assignatura_titulacions_actives" v-bind:key="titulacio.id"  class="d-flex w-100 justify-content-between">
                        <router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link>
                        <span v-if="getTipusAssignatura(response.assignatura.assignatura_tipus, index) === 'OB'" class="mb-1"><span class="badge badge-upc">{{ $t('OB') }}</span></span>
                        <span v-else-if="getTipusAssignatura(response.assignatura.assignatura_tipus, index) === 'OP'" class="mb-1"><span class="badge badge-upc-2">{{ $t('OP') }}</span></span>
                        <span v-else-if="getTipusAssignatura(response.assignatura.assignatura_tipus, index) === 'ALE'" class="mb-1"> <span class="badge bg-danger">{{ $t('ALE') }}</span></span>
                        <span v-else class="mb-1"><span class="badge bg-dark">{{ $t('OTHER') }}</span></span>
                    </div>
                  </div>
                </div>



                <div class="row mb-2" v-if="response.assignatura.assignatura_titulacions_no_actives">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions NO actives')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="titulacio in response.assignatura.assignatura_titulacions_no_actives" v-bind:key="titulacio.id">
                      <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link></div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <img src="../assets/images/mini-rss.svg" width="20" alt="user" class="me-1">
                  <a class="me-4" :href="'https://apren.upc.edu/api/RSS/' + response.assignatura.id" target="_blank" rel="noreferrer noopener">{{$t('RSS')}}</a>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>



    <a @click='hideShowDocenciaFunction()' style="cursor:pointer;" class="text-secondary mr-1">
      <h2 class="mt-5">
        <i v-if="!hideShowDocencia" class="fa-regular fa-plus me-2"></i>
        <i v-if="hideShowDocencia" class="fa fa-minus me-2"></i>
        {{$t('Docencia')}}
      </h2>
    </a>

    <div v-if="hideShowDocencia">

      <div class="row">

        <div v-if="responseDocencia.length === 0" class="alert alert-danger rounded-0" role="alert">
          {{ $t("No results") }}
        </div>
        <div v-else class="col-sm-12 col-md-12">

            <div class="row">
              <div v-for="(docencia, index) in responseDocencia.docencia" :key="index" class="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4">
                <div class="type-card h-100">
                  <!-- Header: Cyan for Q1, Steel (Dark grey) for Q2 -->
                  <div class="type-card-header type-header-steel">
                    <i class="fa-solid fa-calendar-days type-card-icon"></i>
                    <h3 class="type-card-title">Curs: {{ docencia.data }}/{{ parseInt(docencia.data)+1 }}</h3>
                    <span class="quarter-badge ms-auto" :class="docencia.activitat_quadrimestre === '1' ? 'bg-primary text-white' : 'bg-warning text-white'">
                      Q{{ docencia.activitat_quadrimestre }}
                    </span>
                  </div>
                  
                  <ul class="type-list">
                    <!-- Responsables -->
                    <template v-if="docencia.activitat_responsable">
                      <li v-for="(professor) in docencia.activitat_responsable" :key="professor" class="type-list-item">
                        <span class="badge rounded-pill ms-1 bg-danger">R</span>
                        <span v-if="professor.indexOf('##') === -1 || professor.split('##')[1] === ''" class="fw-bold text-dark">{{professor}}</span>
                        <router-link v-else :to="{name: 'professor', params: {id: professor.split('##')[1]}}" class="text-success fw-bold">
                          {{professor.split("##")[0]}}
                        </router-link>
                      </li>
                    </template>

                    <!-- Altres professors -->
                    <template v-if="docencia.activitat_professors">
                      <li v-for="(professor) in docencia.activitat_professors" :key="professor" class="type-list-item">
                        <span class="type-bullet"></span>
                        <span v-if="professor.indexOf('##') === -1 || professor.split('##')[1] === ''" class="text-secondary">{{professor}}</span>
                        <router-link v-else :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                          {{professor.split("##")[0]}}
                        </router-link>
                      </li>
                    </template>
                  </ul>
                  
                  <div class="mt-auto px-3 pb-3" v-if="isGuiaDisponible(docencia.data, getIdiomaForGuia(locale))">
                     <router-link-locale 
                       :to="{name: 'guiaDocent', params: {id: response.assignatura.id, curs: docencia.data}, query: {page: $route.params.listPage, sort: $route.params.listSort}}" 
                       class="btn btn-innovation w-100"
                     >
                      <i class="fa-solid fa-book-open"></i> {{$t('Guia docent')}} {{ docencia.data }}/{{ parseInt(docencia.data)+1 }}
                    </router-link-locale>
                  </div>
                </div>
              </div>
            </div>


        </div>

      </div>
    </div>


    <a @click='hideShowProfessorsFunction()' style="cursor:pointer;" class="text-secondary mr-1">
      <h2 class="mt-5">
        <i v-if="!hideShowProfessors" class="fa-regular fa-plus me-2"></i>
        <i v-if="hideShowProfessors" class="fa fa-minus me-2"></i>
        {{$t('participants')}}
      </h2>
    </a>

    <div v-if="hideShowProfessors">

      <div class="row">

        <div v-if="responseProfessors.length === 0" class="alert alert-danger rounded-0" role="alert">
          {{ $t("No results") }}
        </div>
        <div v-else class="col-sm-12 col-md-12">
          <ul class="list-unstyled" style="column-count: 4;">
            <!-- class="list-group-item list-group-item-action" style="border-bottom: none; border-top: none ; border-right: none; border-left: none;"-->
            <router-link v-for="(professor) in responseProfessors.professors" :key="professor.id" :to="{name: 'professor', params: {id: professor.id}}">
              <li class="mb-3"><i class="fas fa-user mr-2 text-secondary"></i> {{professor.professor_nom}} ({{professor.professor_num_activitats}})</li>
            </router-link>
          </ul>
        </div>

      </div>
    </div>

    <div class="row mt-5">
      <MaterialsCommon :init-query="initQuery" router-name="assignatura" @updateActivitatCount="handleActivitatCountUpdate"></MaterialsCommon>
    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import {
  getProfessorsParticipantsAssignatura,
  getTipusAssignatura
} from "@/composables/pageFunctions";
import { useI18n } from 'vue-i18n';
import {setMetadataName} from "@/composables/metadataFunctions";
import AssignaturaService from "@/services/AssignaturaService";
import MaterialsCommon from "@/components/MaterialsCommon.vue";

  export default {
    name: "AssignaturaView",
    methods: {getTipusAssignatura},
    components: {MaterialsCommon, RouterLinkLocale},

    setup: function () {
      const {locale} = useI18n();

      const response = ref([]);
      const responseMaterials = ref([]);
      const responseProfessors = ref([]);
      const responseDocencia = ref([]);
      const guiesDisponibles = ref([]);
      const bibliografiaDisponibilitat = ref([]);
      const route = useRoute();

      const initQuery = computed(() => {
        const id = route.params.id;
        return `activitat_assignatures:${id}`;
      });

      const materialCount = ref(0);

      const hideShowProfessors = ref(false)
      const hideShowDocencia = ref(false)

      // Función para actualizar el estado con el número de materiales
      const handleActivitatCountUpdate = (count) => {
        materialCount.value = count
      };

      onMounted(async () => {
        await store.dispatch('updateSearchSelected', "Assignatura");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-green.webp') });
        const id = route.params.id;
        response.value = await AssignaturaService.getAssignatura(id)
        guiesDisponibles.value = await AssignaturaService.getDisponibilitatGuies(id);
        bibliografiaDisponibilitat.value = await AssignaturaService.getDisponibilitatBibliografia(id);
        setMetadataName(response.value.assignatura[`assignatura_nom_${locale.value}`] || response.value.assignatura.assignatura_nom_ca);
      });

      const hideShowProfessorsFunction = async () => {
        if (responseProfessors.value.length === 0) {
          responseProfessors.value = await getProfessorsParticipantsAssignatura(response.value.assignatura.id)
        }
        hideShowProfessors.value = !hideShowProfessors.value
      };

      const hideShowDocenciaFunction = async () => {
        if (responseDocencia.value.length === 0) {
          responseDocencia.value = await await AssignaturaService.getDocencia(response.value.assignatura.id)
        }
        hideShowDocencia.value = !hideShowDocencia.value
      };


      const getIdiomaForGuia = (locale) => {
        if (locale === 'es') return 'CAS';
        if (locale === 'en') return 'ANG';
        return 'CAT';
      }

      const isGuiaDisponible = (curs, idiomaPrisma) => {
        return guiesDisponibles.value.some(g => g.curs == curs && g.idioma == idiomaPrisma);
      }

      const isBibliografiaDisponible = (curs) => {
        return bibliografiaDisponibilitat.value.includes(curs.toString());
      }

      return {
        response,
        responseMaterials,
        responseProfessors,
        responseDocencia,
        locale,
        initQuery,

        hideShowProfessors,
        hideShowProfessorsFunction,
        hideShowDocencia,
        hideShowDocenciaFunction,

        handleActivitatCountUpdate,
        materialCount,
        getIdiomaForGuia,
        isGuiaDisponible,
        isBibliografiaDisponible

      }

    }

  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

/* ════════════════════════════════════════════════
   TYPE CARDS (About View Style)
════════════════════════════════════════════════ */
.type-card {
  --apren-300: #38b6e8;
  --apren-400: #1e90d4;
  --text-secondary: #4a6278;
  --border-color: #d6e8f5;

  background: white;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.28s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
}

.type-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 36px rgba(10, 102, 194, 0.13);
  border-color: #0d3d6b;
}

.type-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.1rem;
}

.type-header-cyan   { background: linear-gradient(135deg, #0891b2, #06b6d4); }
.type-header-steel  { background: linear-gradient(135deg, #334155, #0d3d6b); }

.type-card-icon {
  font-size: 1rem;
  color: rgba(255,255,255,0.9);
}

.type-card-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: white !important;
  margin: 0;
  line-height: 1.3;
  border: none !important;
  padding: 0 !important;
}

.quarter-badge {
  font-size: 0.75rem;
  font-weight: 800;
  padding: 0.2rem 0.6rem;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.q1-badge {
  background: #e53935; /* Red */
  color: white;
}

.q2-badge {
  background: #f6a808; /* Amber */
  color: white;
}

.type-list {
  padding: 0.75rem 1.1rem 1rem;
  margin: 0;
  list-style: none;
  flex-grow: 1;
}

.type-list-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 15px;
  font-weight: 300;
  line-height: 22px;
  color: var(--text-secondary);
  padding: 0.4rem 0;
  border-bottom: 1px solid #f0f6fb;
}

.type-list-item:last-child {
  border-bottom: none;
}

.type-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--apren-400);
  flex-shrink: 0;
}

.text-success.fw-bold {
  color: #2e7d32 !important;
}

.btn-innovation-container {
    padding-top: 10px;
}
</style>
